import { mapGetters } from 'vuex';
import { errorMessage } from '@/utils/message.js';
import accountInfoService from '../account-info.service.js';
import ProcessNavigation from '@/components/process-navigation/index.vue';

export default {
  components: {
    ProcessNavigation
  },
  data() {
    return {
      smsCodeShowCount: 60,
      smsCodeShowText: '获取验证码',
      processList: ['验证身份', '重置密码', '重置成功'],
      step: 2,
      form: {
        mobile: '',
        originalPassWord: '',
        newPassWord: '',
        userType: ''
      },
      rules: {
        originalPassWord: [
          { required: true, message: '请输入登录密码', trigger: 'blur' }
        ],
        newPassWord: [
          { required: true, message: '请输入登录密码', trigger: 'blur'}
        ]
      }
    };
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  created() {
  },
  mounted() {
    this.form.mobile = this.userInfo && this.userInfo.mobile || '1';
    this.form.userType = this.userInfo && this.userInfo.type;
  },
  methods: {
    validateForm() {
      let validStatus = false;
      this.$refs['form'].validate(valid => {
        if (valid) {
          validStatus = valid;
        }
      });
      return validStatus;
    },
    // 上一步
    frontStep() {
      this.$router.back();
    },
    // 下一步
    secondStep() {
      if (!this.validateForm()) { return; };
      accountInfoService.updatePassWord(this.form).then(res => {
        if (res && res.code === '0') {
          this.$router.push('/person-center/account-info/reset-success');
        } else {
          errorMessage(res.reason);
        }
      }, error => {
        if (error && error.data.reason) {
          errorMessage(error.data.reason);
        }
      });
    }
  }
  // resetPassword() {
  // let params = {
  //   mobile: form.mobile,
  //   userType: this.userInfo.type,
  //   originalPassWord: this.form.oldPassword,
  //   newPassWord: this.form.newPassword
  // };
  // accountInfoService.updatePassWord(params).then(res => {
  //   if(res && res.code === '0') {
  //     console.log(res.data);
  //   }
  // });
  // }
};
